import { useEffect, useMemo } from 'react';
import CourtHeader from './CourtHeader';
import BookingButton from './BookingButton';
import { isTimeBetweenRange } from '../utils';
import { useBookingContext } from '../context';
import { isMobile } from 'react-device-detect';

export default ({ courtDetails, slider }) => {
  const { startTime, endTime, setPrice, court } = useBookingContext();
  const roundPrice = (value) => Math.round(value);
  const getMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);

    return hours * 60 + minutes;
  };

  const getSlotPrice = (slot) => {
    const hourlyPrice = slot?.price ?? courtDetails.defaultPrice;
    const durationInHours = (getMinutes(slot.end) - getMinutes(slot.start)) / 60;

    return roundPrice(hourlyPrice * durationInHours);
  };

  const slots = useMemo(() => {
    return [...(Array.isArray(courtDetails.slots) ? courtDetails.slots : [])].sort((a, b) =>
      a.start.localeCompare(b.start)
    );
  }, [courtDetails.slots]);

  const cells = useMemo(() => {
    const boundaryTimes = [...new Set(slots.flatMap((slot) => [slot.start, slot.end]))];

    return boundaryTimes.map((time, index) => {
      const previousSlot = slots[index - 1];
      const nextSlot = slots[index];

      return {
        time,
        isFree: Boolean(previousSlot?.available || nextSlot?.available),
        price: nextSlot ? getSlotPrice(nextSlot) : courtDetails.defaultPrice / 2,
        courtId: courtDetails.courtId,
        courtName: courtDetails.courtName
      };
    });
  }, [courtDetails.courtId, courtDetails.courtName, courtDetails.defaultPrice, slots]);

  useEffect(() => {
    if (court?.courtId && court.courtId !== courtDetails.courtId) {
      return;
    }

    if (!startTime || !endTime) {
      setPrice(0);
    } else {
      const price = slots.reduce((acc, slot) => {
        if (isTimeBetweenRange(slot.start, startTime, endTime, '[)')) {
          return acc + getSlotPrice(slot);
        }

        return acc;
      }, 0);

      setPrice(roundPrice(price));
    }
  }, [startTime, endTime, slots, courtDetails.courtId, courtDetails.defaultPrice, court, setPrice]);

  return (
    <div className="sm:pt-10 lg:pt-10 flex flex-wrap lg:basis-1/4 md:basis-1/2">
      <div className="flex flex-row items-center justify-space w-full px-4 mb-8">
        {isMobile && (
          <div className="flex" onClick={() => slider.slickPrev()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" fill="none">
              <path d="M8.267 15 1.733 8l6.534-7" stroke="#fff" strokeWidth="2" />
            </svg>
          </div>
        )}
        <CourtHeader name={`Корт №${courtDetails.courtName}`} />
        {isMobile && (
          <div className="flex" onClick={() => slider.slickNext()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" fill="none">
              <path d="m.733 1 6.534 7-6.534 7" stroke="#fff" strokeWidth="2" />
            </svg>
          </div>
        )}
      </div>
      <div className="flex flex-wrap w-full flex-row justify-center">
        {cells.map((cell, index) => {
          return (
            <BookingButton
              booking={cell}
              courtDetails={courtDetails}
              key={courtDetails.courtId + index + cell.time}
              cells={cells}
            />
          );
        })}
      </div>
    </div>
  );
};
